import { Locale } from '../../domain/Internationalization/entities';
import { InternationalizationState } from './types';

const DEFAULT_LANGUAGE = new Locale(3, 'en-GB', 'English(UK)', 'EN(UK)', 'English (United Kingdom)');

const defaultInternationalizationState: InternationalizationState = {
  availableLanguages: [DEFAULT_LANGUAGE],
  translations: [],
  language: DEFAULT_LANGUAGE,
  languageChanged: false,
};

export { DEFAULT_LANGUAGE, defaultInternationalizationState };
